import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import RaisedButton from 'material-ui/RaisedButton';

const Wrapper = styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
`;

const raisedButtonStyle = {
    marginLeft: 20
};

const styleWrapperChildComponent = {
    width: '100%',
    maxWidth: '530px',
    display: 'flex',
    justifyContent: 'space-between'
};

function pickerWrapper(ChildComponentClass, type) {
    return class PickerWrapper extends Component {
        static propTypes = {
            onClickSaveBtn: PropTypes.func.isRequired
        };

        state = {
            value: null,
            reset: null,
            error: false
        };

        addTournament = ({ tournamentId }) => {
            if (tournamentId != null) {
                this.setState({ value: tournamentId, reset: false });
            }
        };

        addTeam = (_, teamId) => {
            if (teamId != null) {
                this.setState({ value: teamId, reset: false });
            }
        };

        onChange() {
            if (type === 'tournament') {
                return this.addTournament;
            } else if (type === 'teamIds') {
                return this.addTeam;
            }

            return () => {};
        }

        onSave = () => {
            if (this.state.value) {
                this.props.onClickSaveBtn(this.state.value);

                this.setState({ reset: true });
            } else {
                this.setState({ error: true });
            }
        };

        render() {
            return (
                <Wrapper>
                    {/*{this.state.error && <h6 style={{ color: 'red' }}>Error</h6>}*/}
                    <ChildComponentClass
                        {...this.props}
                        resetPicker={this.state.reset}
                        onChange={this.onChange()}
                        styleWrapper={styleWrapperChildComponent}
                    />
                    <RaisedButton label="Add" onClick={this.onSave} style={raisedButtonStyle} />
                </Wrapper>
            );
        }
    };
}

export default pickerWrapper;



/** WEBPACK FOOTER **
 ** ../src/dash/front/interests-page/components/AddInterestFormDialog/pickerWrapperHOC.js
 **/